export default __webpack_public_path__ + "static/media/logo.38ca5d72.png";